import './news/news';
import './tecdoc/tecdoc';

import './main/main.less';
import './good/good.less';
import './goodsList/goodsList.less';
import './addCartModal/addCart.less';
import './checkout/checkout.less';

import './../core/content/autoparts/autoparts.less';
import './login/login.less';

import './garage/garage.less';
import './vin-request-list/vin-request-list.less';
import './vin-requests/vin-requests.less';
import './vin-request-comments/vin-request-comments.less';
import './laximo-catalog/laximo-catalog.less';
import './related-group/related-group.less';
import './autoservice/autoservice.less';
import './address/address.less';
import './personal/personal.less';
import './vacancies/vacancies.less';
import './delivery/delivery.less';
import './auto-catalog/auto-catalog.less';
import './any-pages/promo-landing.less';
import './auto-catalog/selected-catalog/style.less';
import './review/review.less';
import './review-comment/review-comment.less';
import './marketplace/about-links-modal.js';
import 'desktopeModules/delivery/index.js';

if (document.getElementById('main-page')) {
    import('./main/main').then(function (module) {
        module.default;
    });
}

if (document.getElementById('add-to-cart')) {
    import('./addCartModal/').then(function (module) {
        module.default;
    });
}

if (document.getElementById('good-item')) {
    import('./good/good').then(function (module) {
        module.default;
    });
}

if (document.getElementById('goodsList')) {
    import('./goodsList/goodsList').then(function (module) {
        module.default;
    });
}

if (document.getElementById('garage')) {
    import('./garage/garage').then(function (module) {
        module.default;
    });
}

import('./header-car/headerCar').then(function (module) {
    module.default;
});

if (document.getElementById('checkout')) {
    import('./checkout/checkout').then(function (module) {
        module.default;
    });
}

if (document.getElementById('delay')) {
    import('./checkout/delay/delay').then(function (module) {
        module.default;
    });
}

if (document.getElementById('loginPage')) {
    import('./login/login').then(function (module) {
        module.default;
    });
}

if (document.getElementById('marketplaceAdmin')) {
    import('./marketplace/admin').then(function (module) {
        module.default;
    });
}

if (document.getElementById('vin-requests')) {
    import('./vin-requests/vin-requests').then(function (module) {
        module.default;
    });
}

if (document.getElementById('vin-request-form')) {
    import('./vin-requests/vin-request-form/vin-request-form').then(function (
        module
    ) {
        module.default;
    });
}

if (document.getElementById('vin-request-comments')) {
    import('./vin-request-comments/vin-request-comments').then(function (
        module
    ) {
        module.default;
    });
}

if (document.getElementById('vin-request-list')) {
    import('./vin-request-list/vin-request-list').then(function (module) {
        module.default;
    });
}

if (document.getElementById('laximo-catalog')) {
    import('./laximo-catalog/laximo-catalog').then(function (module) {
        module.default;
    });
}

if (document.getElementById('laximo-wizard')) {
    import('./laximo-catalog/wizard/').then(function (module) {
        module.default;
    });
}

if (
    document.getElementById('cart-related-goods') ||
    document.getElementById('related-goods')
) {
    import('./related-group/related-group').then(function (module) {
        module.default;
    });
}

if (document.getElementById('autoservice-list')) {
    import('./autoservice/autoservice').then(function (module) {
        module.default;
    });
}

if (document.getElementById('address-list')) {
    import('./address/address').then(function (module) {
        module.default;
    });
}

if (document.getElementById('vacancy-list')) {
    import('./address/vacancy/vacancy').then(function (module) {
        module.default;
    });
}

if (document.getElementById('review')) {
    import('./good/good').then(function (module) {
        module.default;
    });
}

if (document.getElementById('warehouse')) {
    import('./warehouse/warehouse').then(function (module) {
        module.default;
    });
}

if (document.getElementById('order-one')) {
    import('./personal/order/order').then(function (module) {
        module.default;
    });
}

if (document.getElementById('setDiscount')) {
    import('./personal/discount-card/discount-card').then(function (module) {
        module.default;
    });
}

if (
    document.getElementById('personal') ||
    document.getElementById('new-cabinet')
) {
    import('./personal/personal').then(function (module) {
        module.default;
    });
}

if (document.getElementById('vacancies')) {
    import('./vacancies/vacancies.js').then(function (module) {
        module.default;
    });
}

if (document.getElementById('delivery-one')) {
    import('./delivery/delivery').then(function (module) {
        module.default;
    });
}

if (document.getElementById('search-page')) {
    import('./search/searchEvents').then(function (module) {
        module.default;
    });
}

if (document.getElementById('for-bussines-page')) {
    import('./any-pages/for-bussines.less');
    import('./any-pages/for-bussines');
}

if (document.getElementById('order-info-app')) {
    import('mobileModules/order-info').then(function (module) {
        module.default;
    });
}

if (document.getElementById('for-rent-page')) {
    import('./any-pages/for-rent.less');
    import('./any-pages/for-rent');
}

if (document.getElementById('order-info-app')) {
    import('mobileModules/order-info').then(function (module) {
        module.default;
    });
}

if (document.getElementById('auto-catalog')) {
    import('./auto-catalog/auto-catalog').then(function (module) {
        module.default;
    });
}

if (document.getElementById('promo-landing')) {
    import('./any-pages/promo-landing').then(function (module) {
        module.default;
    });
}

if (document.getElementById('promo-landing-goods')) {
    import('./any-pages/promo-landing-goods').then(function (module) {
        module.default;
    });
}

if (document.getElementById('review-page')) {
    import('./review/review.js').then(function (module) {
        module.default;
    });
}

if (document.getElementById('review-comment')) {
    import('./review-comment/review-comment.js').then(function (module) {
        module.default;
    });
}

if (document.getElementById('review-reaction')) {
    import('./review/review-reaction.js').then(function (module) {
        module.default;
    });
}

if (document.getElementById('about')) {
    import('./about/about.js').then(function (module) {
        module.default;
    });
}

if (document.getElementById('about')) {
    import('./about/about.js')
        .then(function (module) {
            module.default;
        })
        .catch(function (err) {
            console.error('Chunk loading failed');
            console.error(err);
        });
}

if (document.getElementById('app-author-page')) {
    import('./author/index.js')
        .then(function (module) {
            module.default;
        })
        .catch(function (err) {
            console.error('Chunk loading failed');
            console.error(err);
        });
}

